import { motion } from "framer-motion";
import styles from "./ConcentricLoader.module.css";
import Delayed from "./Delayed";

function ConcentricLoader({
  className = "",
  colorVar = "primary-color",
  waitBeforeShow = 750,
}: {
  className?: string;
  colorVar?: string;
  waitBeforeShow?: number;
}): JSX.Element {
  const colorStyle = {
    borderColor: `transparent var(--${colorVar}) transparent var(--${colorVar})`,
  };
  return (
    <Delayed waitBeforeShow={waitBeforeShow}>
      <motion.div
        className={`${styles.container} ${className}`}
        initial={{ scale: 1 }}
        animate={{ scale: 1.3 }}
        transition={{
          ease: "linear",
          duration: 1,
          repeat: Infinity,
          repeatType: "reverse",
        }}
      >
        <div className={styles.circle} style={colorStyle}>
          <div className={styles.circle} style={colorStyle}>
            <div className={styles.circle} style={colorStyle}></div>
          </div>
        </div>
      </motion.div>
    </Delayed>
  );
}

export default ConcentricLoader;
